import type { MapState } from '@tmapy/beetlejuice-utils';
import {
  MapCoreActions,
  mapCore as mapCoreDefaultReducer,
  getMapCoreInitialState,
} from '@tmapy/mapcore';

import { NEW_ORDER_CLEAR } from '../orders/constants';
import type { ActionNewOrderClear } from '../orders/actions/newOrder';

const mapCoreInitialState = getMapCoreInitialState();

const mapState: MapState = {
  ...mapCoreInitialState,
};

export const mapCore = (
  state: MapState = mapState,
  action: MapCoreActions | ActionNewOrderClear,
): MapState => {
  switch (action.type) {
    // TODO: stary pristup, nove popuzivat middleware
    case NEW_ORDER_CLEAR:
      return mapState;
    default:
      return mapCoreDefaultReducer(state, action);
  }
};
